/**
 * Created by mongoose on 14/11/17.
 */
import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { FormGroup } from "react-bootstrap";
// @ts-ignore
import DualListBox from "react-dual-listbox";
import "react-dual-listbox/lib/react-dual-listbox.css";
import { defineMessages, useIntl } from "react-intl";
import styled from "styled-components";

// Disabled options (e.g. engines already assigned to another aggregator) render in this muted
// grey across every property selector, regardless of the manager that uses the widget.
const DualListBoxWrapper = styled.div`
  .rdl-control option:disabled {
    color: #dcdcdc;
  }
`;

export const messages = defineMessages({
  search: {
    id: "widget.duallistbox.search",
    description: "placeholder",
    defaultMessage: "Search...",
  },
});

export interface ValueOption<T> {
  label: string;
  value: T;
  disabled?: boolean;
}

interface Field<T> {
  fieldName: string;
  options: ValueOption<T>[];
  disabled: boolean;
  leftListHeader: string;
  rightListHeader: string;
  filterPlaceholder: string;
}

function DualListBoxGroup<T>({
  value,
  onChange,
  field,
}: {
  value: T[];
  onChange: ({ value, field }: { value: T[]; field: Field<T>["fieldName"] }) => void;
  field: Field<T>;
}) {
  const {
    fieldName,
    options,
    disabled,
    leftListHeader,
    rightListHeader,
    filterPlaceholder,
  } = field;
  const intl = useIntl();
  const filterBarMessage = filterPlaceholder || intl.formatMessage(messages.search);
  const handleChange = useCallback(
    (values: T[]) => {
      // react-dual-listbox's "move all" (>>) does not honour per-option `disabled`, so strip
      // disabled values from the emitted selection to keep them unselectable via every path.
      const disabledValues = new Set(options.filter(o => o.disabled).map(o => o.value));
      onChange({ value: values.filter(value => !disabledValues.has(value)), field: fieldName });
    },
    [onChange, fieldName, options]
  );

  return (
    <DualListBoxWrapper>
      <FormGroup>
        <DualListBox
          options={options}
          selected={value}
          onChange={handleChange}
          disabled={disabled}
          // @ts-ignore
          filterPlaceholder={filterBarMessage}
          lang={{ availableHeader: leftListHeader, selectedHeader: rightListHeader }}
          showHeaderLabels
          canFilter
        />
      </FormGroup>
    </DualListBoxWrapper>
  );
}

DualListBoxGroup.propTypes = {
  field: PropTypes.object,
  formErrors: PropTypes.object,
  formValues: PropTypes.object,
  hasErrors: PropTypes.bool,
  onChange: PropTypes.func,
};

export default DualListBoxGroup;
